// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"25a92b0d","582":"8689a306"}[chunkId] + ".chunk.css";
};